import React from "react";

export default function SbornikiAppPP() {
  return (
    <div style={{ color: "black", textAlign: "start", margin: "25px" }}>
      <title>Privacy Policy</title>

      <strong>Privacy Policy</strong>
      <p>
        This privacy policy applies to the Сборники Союза app (hereby referred
        to as "Application") for mobile devices that was created by Robert
        Gordiyevych (hereby referred to as "Service Provider") as a Free
        service. This service is intended for use "AS IS".
      </p>
      <br />
      <strong>
        What information does the Application obtain and how is it used?
      </strong>
      <p>
        The Application does not obtain any information when you download and
        use it. Registration is not required to use the Application.
      </p>
      <br />
      <strong>
        Does the Application collect precise real time location information of
        the device?
      </strong>
      <p>
        This Application does not collect precise information about the location
        of your mobile device.
      </p>
      <br />
      <strong>
        Do third parties see and/or have access to information obtained by the
        Application?
      </strong>
      <p>
        Since the Application does not collect any information, no data is
        shared with third parties.
      </p>
      <br />
      <strong>What are my opt-out rights?</strong>
      <p>
        You can stop all collection of information by the Application easily by
        uninstalling it. You may use the standard uninstall processes as may be
        available as part of your mobile device or via the mobile application
        marketplace or network.
      </p>
      <br />
      <strong>Security</strong>
      <p>
        The Service Provider is concerned about safeguarding the confidentiality
        of your information. However, since the Application does not collect any
        information, there is no risk of your data being accessed by
        unauthorized individuals.
      </p>
      <br />
      <strong>Changes</strong>
      <p>
        This Privacy Policy may be updated from time to time for any reason. The
        Service Provider will notify you of any changes to their Privacy Policy
        by updating this page with the new Privacy Policy. You are advised to
        consult this Privacy Policy regularly for any changes, as continued use
        is deemed approval of all changes.
      </p>
      <br />
      <p>This privacy policy is effective as of 2026-03-01</p>
      <br />
      <strong>Your Consent</strong>
      <p>
        By using the Application, you are consenting to the terms set forth in
        this Privacy Policy now and as amended by the Service Provider.
      </p>
      <br />
      <strong>Contact Us</strong>
      <p>
        If you have any questions regarding privacy while using the Application,
        or have questions about the practices, please contact the Service
        Provider via email at robot095@robot095.com.
      </p>
      <hr />
      <p>
        This privacy policy page was generated by
        <a
          href="https://app-privacy-policy-generator.nisrulz.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          App Privacy Policy Generator
        </a>
        with modifications by{" "}
        <a
          href="https://github.com/RoBoT095"
          target="_blank"
          rel="noopener noreferrer"
        >
          Robert Gordiyevych
        </a>
      </p>
    </div>
  );
}
